import axios from 'axios';
import { API_BASE_URL1, API_BASE_URL3 } from '../Components/Services/baseApiUrl';

// Create an Axios instance with common settings
const axiosInstance = axios.create({
  baseURL: API_BASE_URL1,
  baseURL: API_BASE_URL3, // Replace with your API base URL
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add a request interceptor to include the token in every request
axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token'); // Get the token from localStorage
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // Attach the token to Authorization header
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      localStorage.clear();
      window.location.href = '/'; // Redirect to login page
    }
    if (error.request) {
      console.error('No response received:', error, error.message);
      if(error.message === "Network Error") {
        localStorage.clear();
        window.location.href = '/'; // Redirect to login page
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
